module.exports = __webpack_public_path__ + "static/img/7.f072a39.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/3/sp/7.png
// module id = 00Ds
// module chunks = 0